import Category from '../models/category';

export default class CategoryService {
  GetAll() {
    //TODO: CALL API
    // const response = await fetch('https://jsonplaceholder.typicode.com/posts');

    // if (!response.ok) {
    //   if (response.status ==  401)
    //     throw new Error('No estas autorizado para traer categorias');
    //   else if (response.status ==  403)
    //   throw new Error('Estas autorizado pero no para traer categorias');
    //   else 
    //     throw new Error('Error al obtener las categorias');
    // }

    // const articulos = await response.json();
    var categories = [
        { id: "1", name: "Ropa", isRapidSearchType: true},
        { id: "2", name: "Electrodomesticos", isRapidSearchType: true},
        { id: "3", name: "Herramientas", isRapidSearchType: false},
        { id: "4", name: "Autos", isRapidSearchType: true}]

    return categories.map(category => new Category(category.id, category.name, category.isRapidSearchType));
  }  
}